import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import SwitchCustom from 'components/form/SwitchCustom';
import CustomFields from 'components/custom_fields/CustomFields';

const propTypes = {
  offer: PropTypes.object,
  custom: PropTypes.object,
  override_attributes: PropTypes.bool,
  onChange: PropTypes.func
};

export default class AttributesForm extends React.Component {

  handleCustomChange = (key, value) => {
    let obj = {}
    obj[key] = value || ''

    let custom = Object.assign(this.props.custom, obj);

    this.props.onChange({ custom });
  }

  handleOverrideFormAttributes = () => {
    const override_attributes = !this.props.override_attributes
    this.setCustomFields(override_attributes)
    this.props.onChange({ override_attributes })
  }

  setCustomFields = (override_attributes) => {
    const customKeys = Object.keys(this.props.custom)
    let custom = {}

    if (override_attributes) {
      const attributes = this.getAttributes()

      for (let key in customKeys) {
        const attribute = attributes.find(attr => attr[key])

        if (attribute && attribute[key].defaultValue)
          custom[key] = attribute[key].defaultValue
      }
    }
    this.props.onChange({ custom })
  }

  getAttributes = () => {
    let attr = []
    const offer = this.props.offer || {}
    const attributes = offer.custom || []
    attr = attributes.map(item => {
      let attribute = {}
      attribute[item.key] = { name: item.label, type: item.type, options: item.options, defaultValue: item.defaultValue, col_size: item.col_size }

      return attribute
    })
    return attr
  }

  render() {
    const attributes = this.getAttributes()

    return <Row>
      <Col size={12}>
        <FormGroup className="bg-light p-2">
          <Label>Override Attributes</Label>
          <SwitchCustom name="override_attributes" value={this.props.override_attributes || false} handleOnChange={this.handleOverrideFormAttributes} />
        </FormGroup>
      </Col>
      {this.props.override_attributes && attributes && attributes.map((item, index) => {
        return <Col size={Object.values(item)[0].col_size || 6} key={index}>
          <CustomFields
            config={item}
            onChange={this.handleCustomChange}
            custom={this.props.custom}
            className='flex flex-1'
          />
        </Col>
      })}
    </Row>
  }
}

AttributesForm.propTypes = propTypes
AttributesForm.defaultProps = {}